/** Bosh sahifalar lug'ati (uz) */
export default {
  loadError: "Bosh sahifa yuklanmadi.",
  greeting: { morning: "Xayrli tong, {{name}}", afternoon: "Xayrli kun, {{name}}", evening: "Xayrli kech, {{name}}" },
  eyebrow: "{{date}} · Toshkent {{tashkent}} · Dallas {{dallas}}",
  eyebrowShort: "{{date}} · Toshkent {{tashkent}}",
  callOpen: "Dallasda {{time}} — qo'ng'iroq vaqti, {{left}} qoldi",
  callClosed: "Dallasda {{time}} — qo'ng'iroq vaqti {{at}} da boshlanadi, {{wait}} dan keyin",
  overdue_one: "{{count}} ta kechikkan",
  overdue_other: "{{count}} ta kechikkan",
  nothingOverdue: "kechikkani yo'q",
  addDriver: "Driver qo'shish",
  kpi: {
    newDrivers: "Yangi driverlar",
    submitted: "Carrier'larga yuborilgan",
    waiting_one: "{{count}} ta kutmoqda",
    waiting_other: "{{count}} ta kutmoqda",
    forReply: "carrier javobini",
    hired: "Ishga olingan",
    pending_one: "{{count}} ta tasdiq kutmoqda",
    pending_other: "{{count}} ta tasdiq kutmoqda",
    approved: "menejer tasdiqlagan",
    myBonus: "Mening bonusim",
    estimate: "Taxminiy",
    finalAfter: "tasdiqdan keyin yakuniy",
    hires: "Ishga olinganlar",
    inPipeline: "Jarayonda",
    submittedN_one: "{{count}} ta yuborilgan",
    submittedN_other: "{{count}} ta yuborilgan",
    thisMonth: "shu oyda",
    profit: "Foyda",
    noFees: "To'lovlar yo'q",
    moneyNote: "tushgan {{received}} · xarajat {{cost}}",
    costPerHire: "Bir ishga olish narxi",
    costNote: "xarajatlar + maoshlar + bonuslar",
    avgTime: "O'rtacha ishga olish vaqti",
    retentionChip: "{{pct}} saqlanish",
    retentionNote: "30 kun, 30 kundan o'tganlar",
    vs: "{{month}} ga nisbatan",
    prevIn: "{{month}}: {{count}}",
    noPrev: "{{month}} uchun ma'lumot yo'q",
    same: "{{month}} bilan bir xil",
  },
  today: {
    title: "Bugun",
    overdue_one: "{{count}} ta kechikkan",
    overdue_other: "{{count}} ta kechikkan",
    dueToday_one: "{{count}} ta bugun",
    dueToday_other: "{{count}} ta bugun",
    tomorrow_one: "{{count}} ta ertaga",
    tomorrow_other: "{{count}} ta ertaga",
    all: "Barcha vazifalar",
    empty: "Bugunga vazifa yo'q. Zo'r.",
    markDone: "Bajarildi deb belgilash",
    snooze: "Ertaga 9:00",
    call: "Qo'ng'iroq",
    yours_one: "sizning {{count}} ta driveringiz",
    yours_other: "sizning {{count}} ta driveringiz",
    doneFailed: "Vazifani bajarilgan deb belgilab bo'lmadi",
    snoozed: "Ertaga 9:00 ga kechiktirildi",
  },
  due: { yesterday: "Kecha", today: "Bugun", tomorrow: "Ertaga", overdue: "Kechikkan" },
  attention: {
    trucks: "ta truck: sug'urta yoki inspeksiya muddati {{days}} kun ichida",
    title: "E'tibor kerak",
    live: "Jonli",
    noContact: "{{days}}+ kun bog'lanilmagan",
    waitingDocs: "majburiy hujjati yetishmaydi",
    docsExpired: "hujjat muddati tugagan",
    cdl: "CDL 30 kun ichida tugaydi",
    cdlOne: "CDL {{days}} kunda tugaydi",
    carrier: "carrier javobi 3+ kun kechikkan",
    stale: "driver {{days}}+ kun bir bosqichda",
    overdue: "recruiterlarda kechikkan eslatma",
    quiet: "recruiter {{days}}+ kun jim",
    approvals: "tasdiq qaroringizni kutmoqda",
    allClear: "Hammasi joyida — hozir e'tibor talab qiladigan narsa yo'q.",
    andMore_one: "va yana {{count}} ta",
    andMore_other: "va yana {{count}} ta",
  },
  pipeline: {
    title: "Mening pipeline'im",
    branch: "Pipeline",
    active_one: "{{count}} ta faol",
    active_other: "{{count}} ta faol",
    board: "Doskani ochish",
    empty: "Hali faol driverlar yo'q.",
  },
  recent: { title: "Yaqinda yangilangan", all: "Barcha driverlar", empty: "Hali driverlar yo'q. Birinchi driverni qo'shing." },
  leader: {
    sub: "{{month}} · ishga olishlar",
    you: "(siz)",
    rank: "Siz {{of}} tadan {{pos}}-o'rindasiz",
    myPage: "Mening sahifam",
    top: "Eng yaxshi recruiterlar",
    allPeople: "Barcha xodimlar",
    none: "Bu oyda hali tasdiqlangan ishga olish yo'q.",
    without_one: "{{count}} ta recruiterda hali ishga olish yo'q",
    without_other: "{{count}} ta recruiterda hali ishga olish yo'q",
    hires_one: "{{count}} ta ishga olish",
    hires_other: "{{count}} ta ishga olish",
  },
  company: {
    title: "Kompaniya pulsi",
    line: "{{days}} kundan {{day}}-kun · {{branches}} filialda {{recruiters}} recruiter · bu hafta {{activities}} ta faollik",
    lineBranch: "{{days}} kundan {{day}}-kun · {{recruiters}} recruiter · bu hafta {{activities}} ta faollik",
  },
  branches: {
    title: "Filiallar",
    compare: "Hisobotlarda solishtirish",
    rowHint: "Qator bosilsa — shu filial",
    back: "Barcha filiallar",
    cols: { branch: "Filial", recruiters: "Recruiterlar", new: "Yangi", submitted: "Yuborilgan", hired: "Ishga olingan", retention: "Saqlanish", pipeline: "Jarayonda" },
  },
  months: { title: "Ishga olishlar", sub_one: "oxirgi 12 oy · jami {{count}}", sub_other: "oxirgi 12 oy · jami {{count}}", trends: "Trendlar" },
  weeks: { title: "Haftalik ishga olishlar", sub: "tasdiqlangan · 8 hafta" },
  money: {
    title: "Pul",
    sub: "{{month}} · USD",
    finance: "Moliya",
    expected: "Kutilgan",
    received: "Tushgan",
    cost: "Xarajat",
    profit: "Foyda",
    noFees_one: "{{month}}dagi {{count}} ta ishga olish uchun carrier to'lovi kiritilmagan",
    noFees_other: "{{month}}dagi {{count}} ta ishga olish uchun carrier to'lovi kiritilmagan",
  },
  funnel: { title: "Voronka", sub: "{{month}} · oldingi bosqichdan %", lost_one: "Yo'qotilgan {{count}}", lost_other: "Yo'qotilgan {{count}}" },
  manager: {
    line: "{{scope}} · {{recruiters}} recruiter · {{approvals}} · {{overdue}}",
    approvalsWaiting_one: "{{count}} ta tasdiq kutmoqda",
    approvalsWaiting_other: "{{count}} ta tasdiq kutmoqda",
    tasksOverdue_one: "{{count}} ta vazifangiz kechikkan",
    tasksOverdue_other: "{{count}} ta vazifangiz kechikkan",
    teamTitle: "Jamoa bugun",
    team: "Jamoa",
    teamSub: "hozir {{active}} ta faol · bu hafta {{quiet}} ta jim",
    cols: { recruiter: "Recruiter", callsToday: "Bugun qo'ng'iroq", submitted: "Yuborilgan", hired: "Ishga olingan", last: "Oxirgi faollik" },
    quietDays_one: "{{count}} kun jim",
    quietDays_other: "{{count}} kun jim",
    never: "Hali faollik yo'q",
    more_one: "yana {{count}} ta recruiter",
    more_other: "yana {{count}} ta recruiter",
    showAll: "Hammasini ko'rish",
    noRecruiters: "Bu doirada hali recruiterlar yo'q.",
    approvals: "Tasdiqlashlar",
    waiting_one: "{{count}} ta kutmoqda",
    waiting_other: "{{count}} ta kutmoqda",
    reviewAll: "Hammasini ko'rish",
    openDriver: "Driverni ochish",
    approve: "Tasdiqlash",
    reject: "Rad etish…",
    approved: "Tasdiqlandi: {{name}}",
    approveFailed: "Tasdiqlab bo'lmadi",
    noApprovals: "Qaroringizni kutayotgan so'rov yo'q.",
    recruiters: "Recruiterlar",
    recruitersSub: "{{month}} · qator bosilsa — xodim sahifasi",
    reports: "Hisobotlar",
    cols2: { new: "Yangi", contacted: "Bog'lanilgan", submitted: "Yuborilgan", hired: "Ishga olingan", conv: "Konv.", days: "O'rt. kun", recruiters: "Recruiterlar", retention: "Saqlanish" },
    myDrivers: "Mening driverlarim",
  },
};
